import { Box, Chip, Container, Divider, Paper, Stack, Typography, Alert } from '@mui/material';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { LEGAL_CONTENT } from '../legalContent';

export default function LegalDocumentPage() {
  const location = useLocation();

  const documentKey = useMemo(() => {
    if (location.pathname === '/confidentialite') {
      return 'privacy';
    }

    return 'terms';
  }, [location.pathname]);

  const document = LEGAL_CONTENT[documentKey];

  return (
    <Container maxWidth="md" sx={{ pt: 16, pb: 8 }}>
      <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 4 }}>
        <Stack spacing={3}>
          <Chip label={document.badge} sx={{ alignSelf: 'flex-start' }} />
          <Box>
            <Typography variant="h3" gutterBottom>
              {document.title}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {document.intro}
            </Typography>
          </Box>
          <Alert severity="warning" variant="outlined">
            {document.warning}
          </Alert>
          {document.sections.map((section) => (
            <Stack key={section.title} spacing={1.5}>
              <Divider />
              <Typography variant="h5">{section.title}</Typography>
              {section.body.map((paragraph) => (
                <Typography key={paragraph} variant="body1" color="text.secondary">
                  {paragraph}
                </Typography>
              ))}
            </Stack>
          ))}
        </Stack>
      </Paper>
    </Container>
  );
}